<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <fencing-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></fencing-add-form>
                <fencing-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></fencing-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import FencingAddForm from './forms/add/representations/WizardForm'
    import FencingUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../fencingStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            FencingAddForm,
            FencingUpdateForm
        },

    }
</script>
